/**
 * Will append all string conditionally
 * @param {any[]} args A list of string to append together with spaces
 * @returns {string}
 */
function stringBuilder(...args: any[]): string{
    return args.reduce<string>((finalString, arg) => {
        if(typeof arg === 'string'){
            return finalString += prependSpace(arg);
        }
        else if(typeof arg === "object"){
            for (const key in arg) {
                if (Object.prototype.hasOwnProperty.call(arg, key) && arg[key]) {
                    finalString += prependSpace(key);
                }
            }
        }
        return finalString;
    }, '').trim();
}

function prependSpace(string: string): string{
    return ` ${string}`;
}

export default stringBuilder;